import type { FaireProductEntity } from "../../entity_types/product";

export const p_q5yt6mpwe2: FaireProductEntity = {
  token: "p_q5yt6mpwe2",
  type: "product",
  name: "HAND-PAINTED LIGHT LUXURY NECKLACE_CWAJE1594",
  brandToken: "b_3eopd3scey",
  brandName: "ACCITY",
  imageUrl:
    "https://cdn.faire.com/fastly/67f88052cc6c111677a21a4b98a6c52e2b0735368bf635e9b805f0847ba60e2a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6f42acd2869bfb2b2388e63fd3d78d3d51e51f810582f55b793a706ae183172d.jpeg",
    "https://cdn.faire.com/fastly/a05fa82154d6d5f94f523bd31c17418f7a622555225f4a7d18776cad9e7420a2.jpeg",
    "https://cdn.faire.com/fastly/ac3db2e1973f1091efdcd77bfe84624cecc6661856bee8faaec5c970f3c24246.jpeg",
    "https://cdn.faire.com/fastly/bade89989faeaada4ce46966b21ead82f84cad91e738a669ff8e07189cb10bfc.jpeg",
    "https://cdn.faire.com/fastly/330ae886dfdde09a88646bb337f8943f18b9b1802f6652eeefb1534fc509b891.jpeg",
    "https://cdn.faire.com/fastly/e80041489988b0a1063de3401b57e20be2b9b70c13066008c316f639b6d1febe.jpeg",
    "https://cdn.faire.com/fastly/96b0c185824fce037ad2e23797a50d3f3a1da9c5a13d56c2727766e0408a1d02.jpeg",
    "https://cdn.faire.com/fastly/3fd7083ae2188a080aaedf5ac6532ec09faa4a629038ee6f1cfafbc4faa93979.jpeg",
    "https://cdn.faire.com/fastly/7f6ae28ced5cc59b7ee5936226b91c1e5123817c08a787a44b67bc795d5167f0.jpeg",
    "https://cdn.faire.com/fastly/f24b7a20eb1b0c19296ed3730662cc6e118936aa8cfa02d7ea620264c3fd1d16.jpeg",
    "https://cdn.faire.com/fastly/c1b4b1d61c19be1d6454f7a35cdf9f0860bed4796db0a9dc8f00e0182805e2ea.jpeg",
    "https://cdn.faire.com/fastly/ed8bda4400b4cbb6fe5441989acef473aa236c719763b6a1ed6facc5cb7d2012.jpeg",
    "https://cdn.faire.com/fastly/2b512b06c33e2bf765319098155af5b38104f04565caacd9246a904bc5092b10.jpeg",
  ],
  priceDollars: 12.82,
  description:
    "HAND-PAINTED LIGHT LUXURY NECKLACE\nSIZE:OS(2)\n100% TITANIUM STEEL\nMADE IN CHINA\n\nPENDANT NECKLACE, WOMEN'S PENDANT NECKLACE, COUPLE'S PENDANT NECKLACE, CRYSTAL NECKLACE, STAINLESS STEEL NECKLACE, HEART-SHAPED STAINLESS STEEL NECKLACE, STAINLESS STEEL NECKLACE PENDANT, STAINLESS STEEL JEWELRY, LETTER JEWELRY NECKLACE, LETTER P NECKLACE PENDANT, HEART-SHAPED PENDANT NECKLACE, SQUARE PENDANT NECKLACE, ROUND PENDANT NECKLACE, BEACH NECKLACE, ROUND BEACH SHELL NECKLACE, JEWELRY NECKLACE, CUTE PENDANT NECKLACE, GORGEOUS PENDANT NECKLACE, FASHIONABLE PENDANT NECKLACE, VINTAGE PENDANT NECKLACE, 18K GOLD PLATED NECKLACE, NECKLACE SET, NECKLACE EARRING SET, DIAMOND PENDANT NECKLACE, BOHO STYLE PENDANT NECKLACE, BOHO PENDANT NECKLACE, BEST SELLING PENDANT NECKLACE, MOST POPULAR PENDANT NECKLACE, BOHO, BOHO, BEST SELLING, TRENDING, NEW PRODUCTS, HOT SELLING, TOP STORES, HIGH SALES, BEST PRICE, CLEARANCE, FASHION, FLASH SALE, GOOD QUALITY, REDUCED PRICE, 2024 NEW STYLE",
  tags: [],
  msrpDollars: 25.64,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:00.399Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
